import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import {
    inject,
    isDevMode,
    NgModule,
    PLATFORM_ID,
    provideAppInitializer,
    provideEnvironmentInitializer,
} from '@angular/core';
import { BrowserModule, provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@core-app/layout/layout.module';
import { X_SERVICE_ZONE } from '@core-app/tokens';
import { appReducer, CacheService, CoreModule, metaReducers, SettingsService } from '@gallaghercp/core-frontend';
import { StoreModule } from '@ngrx/store';
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_CONFIG as LOCAL_APP_CONFIG } from './app.config';
import { StoreRouterConnectingModule } from '@ngrx/router-store';

@NgModule({
    declarations: [AppComponent],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        CoreModule,
        LayoutModule,
        StoreModule.forRoot({ app: appReducer }, { metaReducers }),
        StoreRouterConnectingModule.forRoot(),
    ],
    providers: [
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        provideClientHydration(withNoHttpTransferCache()),
        {
            provide: X_SERVICE_ZONE,
            useFactory: () => {
                const cacheService = inject(CacheService);
                const storedValue = cacheService.getFromStorage('x-service-zone');
                return storedValue ?? '1';
            },
        },
        provideAppInitializer(() => {
            const initializerFn = initialiseAppConfig(inject(SettingsService), inject(PLATFORM_ID));
            return initializerFn();
        }),
    ],
})
export class AppModule {}

export function initialiseAppConfig(settings: SettingsService, platformId: object): () => Promise<any> {
    const config = { ...LOCAL_APP_CONFIG };
    if (!isPlatformServer(platformId) && (LOCAL_APP_CONFIG as any).enableSSR) {
        config.api = '/api/2.0';
    }
    return () => settings.init(config);
}
